import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedProject } from '../../../../redux/projects/actions';
import API from '../../../../services/api';
import CreateForm from './createForm';
import UpdateForm from './updateForm';
import Loading from '../../../../components/loading';

const Integration = ({ site, createMode, updateSite }) => {
  const [mapping, setMapping] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const project = useSelector(getSelectedProject);

  useEffect(() => {
    if (createMode) {
      setIsLoading(false);
      return;
    }
    fetchMappings();
  }, []);

  const fetchMappings = async () => {
    if (project) {
      setIsLoading(true);
      const filter = encodeURI(`siteId = "${site.id}"`);
      API.getMappings(project.id, '', filter)
        .then(res => {
          setMapping(res.mappings[0] || null);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <>
      <h4 className="section-label">Configure the Site CMS Integration.</h4>
      <div className="assets">
        {isLoading ? (
          <Loading size={8} />
        ) : mapping ? (
          <UpdateForm mapping={mapping} onUpdate={() => fetchMappings()} />
        ) : (
          <CreateForm site={site} onCreate={() => fetchMappings()} createMode={createMode} updateSite={updateSite} />
        )}
      </div>
    </>
  );
};

export default Integration;
